"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpSelect2 = void 0;
const _ = __importStar(require("lodash"));
const vue_1 = __importDefault(require("vue"));
const debug_1 = __importDefault(require("debug"));
const vue_property_decorator_1 = require("vue-property-decorator");
const core_1 = require("@popperjs/core");
const gettext_1 = require("@integro/gettext");
const select2_html_1 = __importDefault(require("./select2.html"));
require("./select2.scss");
const log = (0, debug_1.default)('itp:ui:components:forms:select2');
const isAsyncOptions = (value) => _.isFunction(value);
function defaultMessages() {
    return {
        noOptions: (0, gettext_1.pgettext)('Select2', 'No matching options')
    };
}
let ItpSelect2 = class ItpSelect2 extends vue_1.default {
    selectOptions;
    internalValue;
    autocomplete;
    name;
    autoscroll;
    clearable;
    prefetch;
    disabled;
    readonly;
    filterable;
    inputId;
    form;
    loading;
    multiple;
    placeholder;
    searchable;
    size;
    taggable;
    value;
    initialOptions;
    bindObject;
    dropdownPlacement;
    optionValueField;
    valueField;
    textField;
    textFieldSeparator;
    groupBy;
    groupHeader;
    options;
    footerTemplate;
    headerTemplate;
    listFooterTemplate;
    listHeaderTemplate;
    noOptionsMessage;
    noOptionsTemplate;
    optionTemplate;
    useOptionTemplateForSelectedOption;
    selectedOptionTemplate;
    state;
    onOptionsChanged() {
        this.selectOptions = this.createOptions(this.options, this.initialOptions);
    }
    onValueChanged(value) {
        this.internalValue = value;
    }
    onInternalValueChanged(value) {
        this.$emit('input', value);
    }
    data() {
        return {
            messages: defaultMessages(),
            internalValue: this.value,
            selectOptions: this.createOptions(this.options, this.initialOptions),
            compiledFooterTemplate: compileTemplate(this.footerTemplate),
            compiledHeaderTemplate: compileTemplate(this.headerTemplate),
            compiledListFooterTemplate: compileTemplate(this.listFooterTemplate),
            compiledListHeaderTemplate: compileTemplate(this.listHeaderTemplate),
            compiledNoOptionsTemplate: compileTemplate(this.noOptionsTemplate),
            compiledOptionTemplate: compileTemplate(this.optionTemplate),
            compiledSelectedOptionTemplate: compileTemplate(this.selectedOptionTemplate ||
                (this.useOptionTemplateForSelectedOption
                    ? this.optionTemplate
                    : undefined)),
            search: _.debounce(_.throttle(this.doSearch, 300), 500)
        };
    }
    get className() {
        return {
            'size-sm': !!this.size,
            'is-invalid': this.state === false,
            'is-valid': this.state === true
        };
    }
    withPopper(dropdownList, component, { width }) {
        dropdownList.style.width = width;
        if (component.$refs.toggle) {
            const popper = (0, core_1.createPopper)(component.$refs.toggle, dropdownList, {
                placement: this.dropdownPlacement,
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -1]
                        }
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({ state }) {
                            component.$el.classList.toggle('drop-up', state.placement === 'top');
                        }
                    }
                ]
            });
            return () => popper.destroy();
        }
    }
    doSearch(query, loading) {
        log('query: %s', query);
        if (!query) {
            return;
        }
        if (isAsyncOptions(this.options)) {
            log('loading....');
            loading(true);
            Promise.resolve(this.options(query))
                .then(result => (this.selectOptions = result))
                .catch(error => this.$imodal.error({ error }))
                .finally(() => loading(false));
        }
    }
    selected() {
        log('selected %o', this.internalValue);
        this.$emit('selected', this.internalValue);
        let option;
        if (this.bindObject) {
            option = this.internalValue;
        }
        else {
            const filter = {};
            filter[this.valueField] = this.internalValue;
            option = _.find(this.selectOptions, filter);
        }
        this.$emit('optionSelected', { value: this.internalValue, option });
    }
    deselected() {
        log('deselected %o', this.internalValue);
        this.$emit('deselected', this.internalValue);
        this.$emit('optionDeselected', { value: this.internalValue });
    }
    createOptions(options, initialOptions) {
        if (_.isArray(options)) {
            return options;
        }
        if (_.isArray(initialOptions)) {
            return initialOptions;
        }
        if (this.value != null && !this.multiple) {
            if (!this.bindObject || this.prefetch) {
                this.loadInitialOptions(this.value);
                return [];
            }
            return [this.value];
        }
        return [];
    }
    loadInitialOptions(value) {
        if (isAsyncOptions(this.options)) {
            Promise.resolve(this.options(value))
                .then(result => (this.selectOptions = result))
                .catch(error => this.$imodal.error({ error }));
        }
    }
    getOptionLabel(obj) {
        let result;
        if (_.isObject(obj)) {
            result = _.isEmpty(obj)
                ? ''
                : getLabel(this.textField, obj, this.textFieldSeparator);
        }
        if (result == null) {
            result = obj;
        }
        return result;
    }
    getOptionKey(obj) {
        let result;
        if (_.isObject(obj)) {
            if (this.optionValueField in obj) {
                result = _.get(obj, this.optionValueField);
            }
            if (result == null && this.valueField in obj) {
                result = _.get(obj, this.valueField);
            }
        }
        if (result == null) {
            result = obj;
        }
        if (result != null && _.isObject(result)) {
            result = _.isEmpty(result) ? '' : JSON.stringify(result);
        }
        return result;
    }
    reduce(obj) {
        if (_.isObject(obj)) {
            if (this.bindObject) {
                return obj;
            }
            return _.get(obj, this.valueField);
        }
        return obj;
    }
    filterBy(option, label, search) {
        return ((label || '').toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1);
    }
};
exports.ItpSelect2 = ItpSelect2;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'off' }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "autocomplete", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "name", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpSelect2.prototype, "autoscroll", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpSelect2.prototype, "clearable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpSelect2.prototype, "prefetch", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpSelect2.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpSelect2.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpSelect2.prototype, "filterable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpSelect2.prototype, "inputId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpSelect2.prototype, "form", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpSelect2.prototype, "loading", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpSelect2.prototype, "multiple", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "placeholder", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpSelect2.prototype, "searchable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpSelect2.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpSelect2.prototype, "taggable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", Object)
], ItpSelect2.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Array)
], ItpSelect2.prototype, "initialOptions", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpSelect2.prototype, "bindObject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'bottom' }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "dropdownPlacement", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'id' }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "optionValueField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'id' }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "valueField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'text' }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "textField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: ' ' }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "textFieldSeparator", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "groupBy", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "groupHeader", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpSelect2.prototype, "options", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "footerTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "headerTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "listFooterTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "listHeaderTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpSelect2.prototype, "noOptionsMessage", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "noOptionsTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "optionTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpSelect2.prototype, "useOptionTemplateForSelectedOption", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpSelect2.prototype, "selectedOptionTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpSelect2.prototype, "state", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('options'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ItpSelect2.prototype, "onOptionsChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ItpSelect2.prototype, "onValueChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('internalValue'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ItpSelect2.prototype, "onInternalValueChanged", null);
exports.ItpSelect2 = ItpSelect2 = __decorate([
    (0, vue_property_decorator_1.Component)({ template: select2_html_1.default })
], ItpSelect2);
function compileTemplate(template) {
    if (template) {
        return {
            ...vue_1.default.compile(template),
            props: [
                'option',
                'deselect',
                'multiple',
                'disabled',
                'loading',
                'searching',
                'filteredOptions',
                'deselect'
            ]
        };
    }
}
function getLabel(textField, data, separator) {
    const values = !textField
        ? [_.get(data, '_label')]
        : textField.split(',').map(p => _.get(data, p.trim()));
    return (values
        .filter(p => !!p)
        .join(separator)
        .trim() || `#error .${textField} from ${JSON.stringify(data)} `);
}
//# sourceMappingURL=select2.js.map